import { BasicAchievementData } from "@goodgamestudios/core";
import { XMLInterfaceObject } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";

import { int } from "@goodgamestudios/math-utilities";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { AchievementsVO } from "../../gamevo/AchievementsVO";
import { Poker2PopUpAchievementDialog } from "../../view/dialogs/achievement/Poker2PopUpAchievementDialog";
import { Poker2PopUpAchievementDialogProperties } from "../../view/dialogs/achievement/Poker2PopUpAchievementDialogProperties";
import { Poker2Model } from "../Poker2Model";

export class Poker2AchievementData extends BasicAchievementData {
    private _achievements: any[];
    private _achievementMaxLevels: number = 0;
    private _achievementLevels: number = 0;
    private _achievementPoints: number = 0;

    constructor(achievementXML: XMLInterfaceObject) {
        super(achievementXML);
    }

    public buildAchievement(voList: Map<any, any>): void {
        this._achievements = new Array();
        if (voList != null) {
            for (let entryList of Array.from(voList.values())) {
                var element: any = entryList;
                if (element === undefined) { continue; }

                if (instanceOfClass(element, "AchievementsVO"))
                    this._achievements.push(VOHelper.clone(element));
            }
        }
    }
    public parse_ALI(paramObject: any): void {
        this.resetAllAchievements();
        if (!paramObject)
            return;
        this._achievementPoints = int(paramObject.ap);
        this.parseAchievementList(paramObject.L);
    }

    private parseAchievementList(params: any[]): void {
        this._achievementLevels = 0;
        this._achievementMaxLevels = 0;
        if (params.length < 1)
            return;
        if (params != null) {
            for (let entryList of params) {
                var item: any = entryList;
                if (!item || !item.length) continue;

                var achievement: AchievementsVO = this.getAchievementById(item.shift());

                if (achievement) {
                    achievement.amount = parseInt(item.shift());
                    this.setCurrentAchievementLevel(achievement);
                    this._achievementLevels += achievement.currentLevel;
                    this._achievementMaxLevels += achievement.maxLevel;
                }
                else {
                    console.log("ERR parseAchievementList", item);
                }
            }
        }
    }

    private setCurrentAchievementLevel(achievement: AchievementsVO): void {
        achievement.currentLevel = 0;
        for (var i: number = 0; i < achievement.steps.length; i++) {
            if (achievement.steps[i] < achievement.amount)
                achievement.currentLevel = i;
            else if (achievement.steps[i] == achievement.amount) {
                achievement.currentLevel = i;
            }
        }
    }

    public earnAchievement(paramsEarn: any): void {
        var achievementId: number = int(paramsEarn.id);
        var achievementRank: number = int(paramsEarn.rank);
        var achievement: AchievementsVO = this.getAchievementById(achievementId);
        achievement.bonusAP = int(paramsEarn.ap);
        achievement.bonusXP = int(paramsEarn.xp);

        var achievementName: string = Poker2Model.languageData.getTextById(this.getAchievementName(achievementId));

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_UP);

        BasicDialogHandler.getInstance().registerDialogs("Poker2PopUpAchievementDialog",
            new Poker2PopUpAchievementDialogProperties(achievement, achievementName, achievementRank), true, BasicDialogHandler.PRIORITY_HIGH);
    }

    private resetAllAchievements(): void {
        this._achievementLevels = 0;
        this._achievementPoints = 0;
        if (this._achievements != null) {
            for (let entryList of this._achievements) {
                var achievement: any = entryList;
                if (achievement === undefined) continue;

                achievement.amount = 0;
                achievement.currentLevel = 0;
            }
        }
    }

    public get achievementArray(): any[] {
        var result: any[] = new Array();
        if (this._achievements != null) {
            for (let entryList of this._achievements) {
                var achievement: any = entryList;
                if (achievement === undefined) continue;
                result.push(achievement);
            }
        }

        return result.sortOn("id", Array.NUMERIC | Array.RETURNINDEXEDARRAY) as any[];
    }
    public get achievementLevels(): number {
        return this._achievementLevels;
    }
    public get achievementPoints(): number {
        return this._achievementPoints;
    }

    public getAchievementName(id: number): string {
        var achievement: AchievementsVO = this.getAchievementById(id);
        return (achievement != null) ? achievement.getVisClassName() : "";
    }

    private getAchievementById(id: number): AchievementsVO {
        if (this._achievements != null) {
            for (let entryList of this._achievements) {
                var achievement: any = entryList;
                if (achievement === undefined) continue;

                if (achievement.id == id)
                    return achievement;
            }
        }
        return null;
    }

    public getWodIdByAchievementId(id: number): number {
        var achievement: AchievementsVO = this.getAchievementById(id);
        return int((achievement != null) ? achievement.id : -1);
    }

    public getAmountToLevel(achievement: AchievementsVO, level: number): number {
        if (level > achievement.steps.length)
            return achievement.amount;
        else
            return achievement.steps[level];
    }

    public getAmountToNextLevelInPercent(achievement: AchievementsVO): number {
        if (achievement.currentLevel >= achievement.maxLevel)
            return 1;
        var toCurrentLevel: number = this.getAmountToLevel(achievement, achievement.currentLevel);
        var toNextLevel: number = this.getAmountToLevel(achievement, achievement.currentLevel + 1);
        var delta: number = int(toNextLevel - toCurrentLevel);
        return (toNextLevel - (toNextLevel - achievement.amount)) / toNextLevel;
    }

    public get achievementMaxLevels(): number {
        return this._achievementMaxLevels;
    }

}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
